<template>
    <section class="item-controls">
        <a href="#" @click.prevent="updateItem('visible',1)" class="btn btn-secondary btn-sm">上架</a>
        <a href="#" @click.prevent="updateItem('visible',0)" class="btn btn-warning btn-sm">下架</a>
        <a href="#" @click.prevent="removeItem" class="btn btn-danger btn-sm">刪除</a>   
    </section>
</template>


<script>
    export default {
        props: ['apiUrl'],

        data() {
            return {
                store: window.store
            }
        },

        methods: {
            updateItem(column, data) {
                let url = this.apiUrl+'/updateMulti';

                let params = {
                    ids: this.store.ids,
                    column: column,
                    data: data
                }
                axios.patch(url, params).then(response => {
                    window.location.reload();
                });
            },

            removeItem() {
                let vm = this;
                swal({

                    icon: 'warning',
                    title: "確定刪除？",
                    text: `選定的 ${vm.store.ids.length}筆資料將從伺服器完全刪除，仍要繼續？`,
                    dangerMode: true,
                    buttons: {
                        cancel: {
                            'text': "取消",
                            'visible': true,
                            'value': false
                        },
                        confirm: {
                            'text': "確定!"
                        }
                    }
                }).then((value) => {
                    if(value){


                    var url = vm.apiUrl+'/deleteMulti';
                    
                   axios.post(url, {ids: vm.store.ids}).then(function(response){
                        
                        swal({
                            title: "資料刪除成功！", 
                            icon: "success"
                        }).then(() => {
                            location.reload();
                        });
                    });
                    }
                });

            }
        }


    }
</script>